// Settings > Study and focus > Class bell: how early to warn, the school days, and your bell times.
// All client-side (app/bell.js).
import { toggle, select, button } from "../ui.js";
import { get, set, subscribe } from "../../shared/settings-store.js";

const DAY_LABELS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function daysControl() {
	const wrap = document.createElement("div");
	wrap.className = "rv-days";
	wrap.setAttribute("role", "group");
	const btns = [];
	DAY_LABELS.forEach((lab, idx) => {
		const b = document.createElement("button");
		b.type = "button";
		b.className = "rv-day";
		b.textContent = lab[0];
		b.title = lab;
		b.setAttribute("aria-label", lab);
		b.addEventListener("click", () => {
			const cur = Array.isArray(get("bellDays")) ? get("bellDays").slice() : [];
			const i = cur.indexOf(idx);
			if (i === -1) cur.push(idx); else cur.splice(i, 1);
			cur.sort((a, c) => a - c);
			set("bellDays", cur);
		});
		btns.push(b);
		wrap.appendChild(b);
	});
	const sync = () => {
		const cur = Array.isArray(get("bellDays")) ? get("bellDays") : [];
		btns.forEach((b, idx) => { const on = cur.indexOf(idx) !== -1; b.dataset.on = on ? "1" : "0"; b.setAttribute("aria-pressed", String(on)); });
	};
	subscribe(sync);
	sync();
	return wrap;
}

function readSchedule() {
	const s = get("bellSchedule");
	return Array.isArray(s) ? s.map((x) => ({ t: String((x && x.t) || ""), label: String((x && x.label) || "") })) : [];
}

function scheduleControl() {
	const wrap = document.createElement("div");
	wrap.className = "rv-sched";
	const listEl = document.createElement("div");
	listEl.className = "rv-sched-list";

	function render() {
		listEl.textContent = "";
		const sched = readSchedule();
		if (!sched.length) {
			const empty = document.createElement("div");
			empty.className = "rv-sched-empty";
			empty.textContent = "No bells yet. Add each time your school's bell rings.";
			listEl.appendChild(empty);
			return;
		}
		sched.forEach((item, i) => {
			const rowEl = document.createElement("div");
			rowEl.className = "rv-sched-row";
			const time = document.createElement("input");
			time.type = "time";
			time.className = "rv-input rv-sched-time";
			time.value = item.t;
			time.addEventListener("change", () => { const cur = readSchedule(); if (cur[i]) { cur[i].t = time.value; set("bellSchedule", cur); } });
			const label = document.createElement("input");
			label.type = "text";
			label.className = "rv-input rv-sched-label";
			label.placeholder = "Label (optional)";
			label.spellcheck = false;
			label.maxLength = 40;
			label.value = item.label;
			label.addEventListener("change", () => { const cur = readSchedule(); if (cur[i]) { cur[i].label = label.value.slice(0, 40); set("bellSchedule", cur); } });
			const rm = document.createElement("button");
			rm.type = "button";
			rm.className = "rv-sched-del";
			rm.setAttribute("aria-label", "Remove the " + (item.t || "") + " bell");
			rm.textContent = "✕";
			rm.addEventListener("click", () => { const cur = readSchedule(); cur.splice(i, 1); set("bellSchedule", cur); render(); });
			rowEl.append(time, label, rm);
			listEl.appendChild(rowEl);
		});
	}
	render();

	const add = button("Add bell", () => { const cur = readSchedule(); cur.push({ t: "08:00", label: "" }); set("bellSchedule", cur); render(); });
	add.classList.add("rv-sched-add");

	// Rebuild from the store on external changes (reset / bundle / another tab), but
	// never while an input here is focused (would clobber in-progress typing).
	subscribe(() => { if (!listEl.contains(document.activeElement)) render(); });

	wrap.append(listEl, add);
	return wrap;
}

// A desktop-notification toggle that also asks the browser for permission the first
// time it's switched on (the standard toggle just flips the setting).
function notifyControl() {
	const b = toggle("bellNotify");
	b.addEventListener("click", () => {
		try { if (get("bellNotify") && window.Notification && Notification.permission === "default") Notification.requestPermission(); } catch (e) {}
	});
	return b;
}

export const bellControls = {
	bellEnabled: () => toggle("bellEnabled"),
	bellWarnMin: () => select("bellWarnMin", [["1", "1 minute"], ["2", "2 minutes"], ["3", "3 minutes"], ["5", "5 minutes"], ["10", "10 minutes"], ["0", "At the bell only"]]),
	bellChime: () => toggle("bellChime"),
	bellNotify: notifyControl,
	bellDays: daysControl,
	bellSchedule: scheduleControl,
};
